import { CosineWaveIcon } from './CosineWaveIcon';

/**
 * author: Haley Halcyon
 * id 4969E6E7-4311-4F1E-B9ED-070DE4473A65
 * name cosine-wave
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cosine-wave.svg
 * tags
 * - Audio 
 */
export const FrequencyIcon = CosineWaveIcon;
export default FrequencyIcon